<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GIIvN8/tc-custom/9781615192243.jpg?1700958098094" alt="This image is the cover for the book How to Change Minds About Our Changing Climate"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">How to Change Minds About Our Changing Climate
      </h1>
      <p class="bookDescription body article font2">
        <p>The book to spark action on the defining challenge of our time In our post-truth world, there’s only one place to turn to if we want to live in reality: science. And the research on climate change is clear: It’s real, it threatens us all, and human activity is the primary cause. This essential handbook dismantles all the most pernicious misunderstandings spread by deniers and replaces them with the truth. Faced with an imperiled planet that we must urgently work to save, we don’t have time for anything else.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Seth B. Darling, Douglas L. Sisterson
      </h2>
      
      <p class="authorDescription body article">Douglas L. Sisterson is a senior manager at Argonne National Laboratory for the US Department of Energy’s Atmospheric Radiation Measurement Climate Research Facility.Seth B. Darling is the director of the Institute for Molecular Engineering at Argonne National Laboratory and a senior scientist at the University of Chicago.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The Experiment
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?e7e553b2